import { useAuth } from '@/contexts/AuthContext'

export function Login() {
  const { signIn } = useAuth()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="text-center">
          <img 
            src="/tipit-logo.svg" 
            alt="TipIT Logo" 
            className="h-12 mx-auto mb-8"
          />
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Přihlášení do kalkulačky
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Pro přístup použijte váš firemní Google účet
          </p>
        </div>
        <button
          onClick={signIn}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
        >
          Přihlásit se Google účtem
        </button>
      </div>
    </div>
  )
}